// Mock data for J Lavaly landing page

export const mockBookings = [];

export const addMockBooking = (booking) => {
  const newBooking = {
    id: Date.now(),
    ...booking,
    createdAt: new Date().toISOString()
  };
  mockBookings.push(newBooking);
  return newBooking;
};

export const services = [
  {
    id: 1,
    title: "Weddings",
    description: "I create unforgettable moments on your special day with soulful live performances that set the perfect atmosphere for your celebration.",
    icon: "heart"
  },
  {
    id: 8,
    title: "Wedding Proposals",
    description: "I help create the perfect moment for your proposal with a romantic live serenade that will make your special question truly unforgettable.",
    icon: "heart"
  },
  {
    id: 2,
    title: "Corporate Events",
    description: "I elevate your corporate functions and grand openings with professional entertainment that impresses clients and guests alike.",
    icon: "briefcase"
  },
  {
    id: 3,
    title: "Private Functions",
    description: "From intimate gatherings to high-end celebrations, I bring sophistication and energy to your private events.",
    icon: "users"
  },
  {
    id: 4,
    title: "Memorial Services",
    description: "I honor loved ones with heartfelt, respectful performances that provide comfort and celebrate life's precious memories.",
    icon: "music"
  },
  {
    id: 5,
    title: "Hotel Residencies",
    description: "I provide regular performances that create ambiance and enhance guest experiences in luxury hotel settings.",
    icon: "building"
  },
  {
    id: 6,
    title: "Restaurant & Bar Venues",
    description: "I deliver live music that transforms dining experiences, creating vibrant atmospheres for guests to enjoy.",
    icon: "utensils"
  },
  {
    id: 7,
    title: "Session Work / Session Singer",
    description: "I bring professional studio expertise and versatile vocal talent to recording projects, backing vocals, and collaborative sessions.",
    icon: "mic",
    image: "https://customer-assets.emergentagent.com/job_kingdom-vocalist/artifacts/7jyo6ejt_IMG_4194.jpeg"
  }
];

export const highlights = [
  {
    id: 1,
    title: "The Kingdom Choir",
    description: "Lead singer of the world-renowned Kingdom Choir",
    featured: true
  },
  {
    id: 2,
    title: "International Performances",
    description: "Performed across multiple countries and cultures"
  },
  {
    id: 3,
    title: "Versatile Artist",
    description: "From intimate settings to large global platforms"
  },
  {
    id: 4,
    title: "Professional Excellence",
    description: "Trusted choice for high-end events and celebrations"
  }
];


export const testimonials = [
  {
    id: 1,
    quote: "J Lavaly made our wedding day absolutely magical. The moment the first note was sung, there wasn't a dry eye in the room. Truly world-class.",
    name: "Sarah & James",
    role: "Wedding, London"
  },
  {
    id: 2,
    quote: "An exceptional performer who brought elegance and energy to our corporate gala. Professional from first contact to the final encore.",
    name: "Daniel Okafor",
    role: "Events Director, Corporate Gala"
  },
  {
    id: 3,
    quote: "The vocal talent is simply breathtaking. Our guests are still talking about the performance months later. Highly recommended.",
    name: "Priya Sharma",
    role: "Private Function Host"
  },
  {
    id: 4,
    quote: "Working with J Lavaly in the studio was a masterclass in versatility and precision. A consummate professional and a joy to collaborate with.",
    name: "Marcus Bennett",
    role: "Music Producer"
  },
  {
    id: 5,
    quote: "We booked J Lavaly for our hotel residency and guest satisfaction soared. The atmosphere created each evening was unforgettable.",
    name: "Elena Rossi",
    role: "Hotel General Manager"
  },
  {
    id: 6,
    quote: "A voice that gives you chills. The proposal serenade J Lavaly performed made the most important question of my life perfect.",
    name: "Tom H.",
    role: "Wedding Proposal"
  }
];
